<template>
<div class="split"></div>
</template>

<script>
export default {

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
.split {
	width: 100%;
	height: 16px;
	border-top: 1px solid rgba(7,17,27,0.1);
	border-bottom: 1px solid rgba(7,17,27,0.1);
	background: #f3f5f7;
}
</style>



// WEBPACK FOOTER //
// src/components/split/split.vue